/**
 *
 * @type {{bindAll: Function, bindToShowConfirmChangeEmailInput: Function, bindChangeDateSelectInput: Function, changeDateSelectInput: Function}}
 */
ACC.account = {

    /**
     *
     */
    bindAll: function () {
        ACC.account.bindToShowConfirmChangeEmailInput();
        ACC.account.bindChangeDateSelectInput();
    },

    /**
     *
     */
    bindToShowConfirmChangeEmailInput: function () {
        $('.control-hide').on('keydown',function () {
            $('.control-hideable').each(function (index) {
                $(this).parent().slideDown();
            })
        });
        $('.control-hide-login').on('keydown',function () {
            $('.control-label-login').each(function (index) {
                $(this).parent().slideDown();
            })
        });
    },

    /**
     *
     */
    bindChangeDateSelectInput: function () {
        $('select#Year').on('change',ACC.account.changeDateSelectInput);
        $('select#Month').on('change',ACC.account.changeDateSelectInput);
    },

    /**
     *
     */
    changeDateSelectInput: function () {
        if ($('select#Year').val() && $('select#Month').val()) {
            $.ajax({
                url: this.getAttribute('data-ajax'),
                cache: false,
                data: {year: $('select#Year').val(), month: $('select#Month').val()},
                type: 'GET'
            }).done( function (result) {
                var selectedIndex = $('select#Day')[0].selectedIndex;
                $('select#Day').children().remove(":not(option:disabled)")
                $.each(result, function (i, item) {
                    $("select#Day").append(new Option(item.code, item.name));
                });
                if ($('select#Day').children().length > selectedIndex) {
                    $('select#Day')[0].selectedIndex = selectedIndex;
                }
            });
        }
    }};
